import React, { Fragment, useState, useEffect } from 'react';
import { array, func, object, string, bool } from 'prop-types';
import styled from 'styled-components';
import { RemoveFromGroupsButtonWithHOC } from 'apps/journey/pages/professional-center/components/remove-from-groups-button';
import withColor from 'util/hoc/with-color';
import GenerateReport from 'library/components/generate-user-report';
import ConfigureColumnsModal from 'apps/journey/pages/professional-center/components/configure-columns-modal';
import { Header2 } from 'library/components/text-elements';
import hasHoc from 'util/hoc/has-hoc';
import SearchQuery from 'pairin-library/components/search-query';

const ActionItemsBody = withColor(styled.div`
  display: flex;
  align-items: center;
  span.resultText {
    margin-right: 1em;
    font-size: 0.875em;
    font-weight: bold;
    color: ${(props) => props.colors.grey1};
  }
`);

const StyledHeaderRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 3em;
  h2 {
    flex: 1;
    margin-right: 0.5em;
  }
`;

export const SearchContext = React.createContext({
  searchMethod: () => {},
  reload: () => {},
  setSearchMethod: () => {},
});

let searchMethod = () => {};

const TableHeader = ({
  className,
  checkAllOnAllPages,
  checked,
  columnConfig,
  baseColumns,
  reload,
  match,
  handleSearch,
  searchQuery,
  dynamic_user_data,
  sortBy,
  ...props
}) => {
  const [columns, setColumns] = useState(baseColumns);

  useEffect(() => {
    if (columnConfig.length < 1) {
      setColumns(baseColumns);
      return;
    }

    let filteredColumns = baseColumns
      .map((baseCol) => {
        let configColumn = columnConfig.find((x) => baseCol.key === x.attr);
        return {
          path: baseCol.key,
          report_attribute: baseCol.report_attribute,
          report_path: baseCol.report_path,
          report_type: baseCol.report_type,
          label: baseCol.label,
          order: configColumn ? configColumn.order : 1,
          show: configColumn ? configColumn.show : baseCol.show,
          computed: baseCol.computed,
        };
      })
      .sort((a, b) => (a.order < b.order ? -1 : 1));

    setColumns(filteredColumns);
  }, [columnConfig]);

  const uuids = () => checked;

  const setSearchMethod = (method) => {
    searchMethod = method;
  };

  return (
    <div className={className}>
      <StyledHeaderRow>
        <Header2>{props.tableTitle}</Header2>
        <SearchQuery
          columnConfig={columnConfig}
          onSearch={handleSearch}
          dependentProps={['organizationId']}
          organizationId={match?.params?.organizationId}
          query={searchQuery}
          dynamic_user_data={dynamic_user_data}
          sortBy={sortBy}
          setSearchMethod={setSearchMethod}
        />
        <ConfigureColumnsModal
          columns={columns}
          tableName="prof_center_professional"
        />
      </StyledHeaderRow>
      <ActionItemsBody>
        {props.resultText && (
          <Fragment>
            <span className="resultText">{props.resultText}</span>
          </Fragment>
        )}
        {props.resultText && (
          <Fragment>
            <GenerateReport
              selected={uuids()}
              allSelected={checkAllOnAllPages}
              userType="professionals"
              columns={JSON.stringify(
                columns.reduce((reportColumns, col) => {
                  if (col.show && !col.computed) {
                    reportColumns.push(col);
                  }
                  return reportColumns;
                }, [])
              )}
            />
            {match?.params?.organizationId ? (
              <RemoveFromGroupsButtonWithHOC
                buttonText="Remove from Organization"
                nodeId={Number(match?.params?.organizationId)}
                uuids={uuids()}
                reloadTable={reload}
              />
            ) : null}
          </Fragment>
        )}
      </ActionItemsBody>
    </div>
  );
};

TableHeader.propTypes = {
  baseColumns: array,
  className: string,
  checked: object,
  columnConfig: array,
  tableTitle: string,
  resultText: string,
  reload_graph: func,
  reload: func,
  match: object,
  checkAllOnAllPages: bool,
  handleSearch: func,
  searchQuery: func,
  dynamic_user_data: array,
  sortBy: string,
};

TableHeader.defaultProps = {
  columnConfig: [],
  reload: () => null,
  reload_graph: () => null,
};

const StyledTableHeader = withColor(styled(TableHeader)`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  width: 100%;
  h2 {
    margin-right: 0.5em;
  }
`);

StyledTableHeader.hoc_list = ['withConfig', 'withRouter'];
export default hasHoc(StyledTableHeader);
